import { render, staticRenderFns } from "./ReportNC.vue?vue&type=template&id=24a7aff7&scoped=true"
import script from "./ReportNC.vue?vue&type=script&lang=js"
export * from "./ReportNC.vue?vue&type=script&lang=js"
import style0 from "./ReportNC.vue?vue&type=style&index=0&id=24a7aff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7aff7",
  null
  
)

export default component.exports